import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=586d0ffe&scoped=true&"
import script from "./Splitter.vue?vue&type=script&lang=ts&"
export * from "./Splitter.vue?vue&type=script&lang=ts&"
import style0 from "./Splitter.vue?vue&type=style&index=0&id=586d0ffe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d0ffe",
  null
  
)

export default component.exports